import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

class DefaultComponentItem {
    constructor(el, index) {
        this.render(el, index);
    }

    render (el, index) {
        this.element = $(el);
    }
}

class DefaultComponent {
    constructor(selector) {
        this.all = document.querySelectorAll(selector);
        for ( var i = 0; i < this.all.length; i++ ) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new DefaultComponentItem(el, index);
    }
}

export default DefaultComponent;
new DefaultComponent('*[data-component="c-default-component"]');